module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "theme-container",
    style: (_vm.containerSize)
  }, [_c('ul', {
    staticClass: "colors-container"
  }, _vm._l((_vm.colors), function(color, index) {
    return _c('li', {
      staticClass: "color-block",
      style: (_vm.setItem(index)),
      on: {
        "click": function($event) {
          _vm.setColor(color)
        }
      }
    })
  })), _c('div', {
    staticClass: "faux-border"
  }, [_c('div', {
    staticClass: "chosen-color",
    style: (_vm.colorBg)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a468d22!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/choice-color.vue
// module id = 56
// module chunks = 1